<ng-container *ngIf="!editing; else editMode">
  <span
    class="fb-inline-text"
    [class.placeholder]="!value"
    (dblclick)="startEdit()"
    [title]="'Double-click to edit'">
    {{ value || placeholder }}
  </span>
</ng-container>
<ng-template #editMode>
  <input
    #inputRef
    type="text"
    class="fb-inline-input"
    [(ngModel)]="editValue"
    (blur)="confirmEdit()"
    (keydown)="onKeydown($event)" />
</ng-template>
